// import React, { useRef, useImperativeHandle, forwardRef, useState } from 'react';
// import CreatableSelect from 'react-select/creatable';

// const CustomComboBox = forwardRef((
//     {
//         options = [],
//         value,
//         inputValue,
//         onChange,
//         onInputChange,
//         placeholder = "Select or type...",
//         ...props
//     },
//     ref
// ) => {
//     const selectRef = useRef();
//     const [menuIsOpen, setMenuIsOpen] = useState(false);

//     useImperativeHandle(ref, () => ({
//         focus: () => selectRef.current?.focus(),
//         openMenu: () => setMenuIsOpen(true),
//         closeMenu: () => setMenuIsOpen(false),
//     }));

//     return (
//         <div className="custom-combo-box-container">
//             <CreatableSelect
//                 ref={selectRef}
//                 isClearable
//                 className="rs-container"
//                 classNamePrefix="rs"
//                 placeholder={placeholder}
//                 options={options}
//                 value={value}
//                 inputValue={inputValue}
//                 onChange={onChange}
//                 onInputChange={(val, meta) => {
//                     if (meta.action === 'input-change') {
//                         onInputChange(val);
//                     }
//                 }}
//                 menuIsOpen={menuIsOpen}
//                 onMenuClose={() => setMenuIsOpen(false)}
//                 onMenuOpen={() => setMenuIsOpen(true)}
//                 {...props}
//                 // ...your styles and formatOptionLabel
//             />
//         </div>
//     );
// });

// export default CustomComboBox;



import React, { useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { Link, useNavigate } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';

export default function CustomComboBox({
    options = [],
    value,
    inputValue,
    onChange,
    onInputChange,
    placeholder = "Select or type...",
    link = null,
    defaultMarginLeft = '-66px',
}) {
    const history = useNavigate();
    return (
        <div className="custom-combo-box-container">

            <CreatableSelect
                isClearable
                className="rs-container"
                classNamePrefix="rs"
                placeholder={placeholder}
                options={options}
                value={value}
                inputValue={inputValue}
                onChange={onChange}
                onInputChange={(val, meta) => {
                    if (meta.action === 'input-change') {
                        onInputChange(val);
                    }
                }}
                // formatOptionLabel={(option, { context }) => {
                //     if (!option) return null;
                //     if (context === 'menu') {
                //     return (
                //         <div
                //         dangerouslySetInnerHTML={{
                //             __html: option.htmlLabel || option.label
                //         }}
                //         />
                //     );
                //     }
                //     return <span>{option.label}</span>;
                // }}
                formatOptionLabel={(option, { context }) => {
                    if (!option) return null;

                    const isCreate = option.__isNew__;
                    const createLabel = option.inputValue || option.label;
                    if (context === 'menu') {
                        if (isCreate) {
                            return (
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span>{createLabel}</span>
                                    {
                                        link && (
                                            <>
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (link) {
                                                            const url = `${window.location.origin}/${link}`;
                                                            window.location.href = url;
                                                        }
                                                        // if (link) {
                                                            
                                                        // }
                                                        // Custom create logic here
                                                    }}
                                                    style={{
                                                        marginLeft: '10px',
                                                        padding: '2px 8px',
                                                        backgroundColor: '#007bff',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '12px',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        gap: '5px',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <div><FaPlus /></div>
                                                    <div>Create</div>
                                                </button>
                                            </>
                                        )
                                    }
                                </div>
                            );
                        }

                        return (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: option.htmlLabel || option.label
                                }}
                            />
                        );
                    }

                    //     return (
                    //         <div
                    //             dangerouslySetInnerHTML={{
                    //                 __html: option.htmlLabel || option.label
                    //             }}
                    //         />
                    //     );
                    // }

                    return <span>{option.label}</span>;
                }}
                styles={{
                    menu: (provided) => ({
                        ...provided,
                        width: '770px', // Adjust the width as needed
                        // width: '57vh', // Adjust the width as needed
                        // width: '799px', // Adjust the width as needed
                        // marginLeft: '-66px',
                        marginLeft: defaultMarginLeft,
                        // marginLeft: '-85px',
                        height: '412px', // Set the maximum height of the dropdown box
                        overflowY: 'auto', // Enable vertical scrolling
                    }),
                    menuList: (provided) => ({
                        ...provided,
                        maxHeight: '402.875px',
                    }),
                    option: (provided, { selectProps, data, isSelected }) => {
                        // Find the index of the current option
                        const index = selectProps.options.findIndex(option => option.value === data.value);
                        return {
                            ...provided,
                            marginBottom: '5px', // Existing space between options
                            marginTop: index === 0 ? '10px' : 0, // Add more spacing on top of the first option
                            backgroundColor: isSelected ? '#DEEBFF' : provided.backgroundColor,
                        };
                    },
                }}
            />
        </div>
    );
}